module.exports = __webpack_public_path__ + "img/gbzythy.5543424f.jpg";